export default __webpack_public_path__ + "static/media/s2-bg-3x.55ea0170.png";